// axios instance 생성 코드
import axios from 'axios';
import { getToken } from 'src/hooks/useLocalStorage';
import { store } from 'src/store';
import { setSnackbarMessage } from 'src/store/snackbarMessage/snackbarSlice';

const jwtToken = getToken();
const client = axios.create({ timeout: 10 * 1000 });
if (jwtToken) {
    client.defaults.headers.common['Authorization'] = `Bearer ${jwtToken}`;
}
client.interceptors.response.use(
    config => config,
    err => {
        if (err?.response?.status === 500 || err?.response?.status === 401 || err?.response?.status === 403) {
            if (
                err.response.data.message.includes('jwt token 검증') ||
                err.response.data.message.includes('유효하지 않는 토큰')
            ) {
                console.log('토큰이 이상해요. 로그인 페이지로');
                const dispatch = store.dispatch;
                dispatch(setSnackbarMessage('토큰 문제 발생'));
                localStorage.removeItem('jwt-token');
                window.location.replace('/login');
            }
        }
        return Promise.reject(err);
    },
);

export const noTimeoutClient = axios.create();
if (jwtToken) {
    noTimeoutClient.defaults.headers.common['Authorization'] = `Bearer ${jwtToken}`;
}
export const addJwtToken = (jwtToken: string): void => {
    if (jwtToken) {
        noTimeoutClient.defaults.headers.common['Authorization'] = `Bearer ${jwtToken}`;
        client.defaults.headers.common['Authorization'] = `Bearer ${jwtToken}`;
    }
};

export default client;
